import { IReportsService } from './contracts/reports.service';
import { createUrl } from '_clean-code/utils/urlHelper';
import apiClient from '../../api/index';
import { DashboardData, GroupedDashboardData } from 'ducks/reports/reducers';

export const ReportsService: IReportsService = {
  getReportDashboards: async (): Promise<DashboardData[]> => {
    const spanishResponse: DashboardData[] = await apiClient.request(
      'GET',
      createUrl('/subscriptions/dashboards')
        .addQueryParam('lang', 'es')
        .toStringUrl()
    );
    const englishResponse: DashboardData[] = await apiClient.request(
      'GET',
      createUrl('/subscriptions/dashboards')
        .addQueryParam('lang', 'en')
        .toStringUrl()
    );

    return [...spanishResponse, ...englishResponse];
  },
  getReportGroupedDashboards: async (): Promise<GroupedDashboardData[]> => {
    const spanishResponse: GroupedDashboardData[] = await apiClient.request(
      'GET',
      createUrl('/subscriptions/dashboards/grouped')
        .addQueryParam('lang', 'es')
        .toStringUrl()
    );
    const englishResponse: GroupedDashboardData[] = await apiClient.request(
      'GET',
      createUrl('/subscriptions/dashboards/grouped')
        .addQueryParam('lang', 'en')
        .toStringUrl()
    );

    return [...spanishResponse, ...englishResponse];
  }
};
